import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import BreadcrumbWithFilter from 'src/components/Common/BreadcrumbWithFilter/BreadCrumbWithFilter';
import { useNavigate, useParams } from 'react-router';
import { ROUTER } from 'src/constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducerState } from 'src/store/reducers';
import { getComplaintDocumentLoading, getComplaintFormByIdLoading, resetComplaintMessage } from 'src/store/actions';
import FileImg from 'src/assets/images/files.png';
import JobTooltipMEL from 'src/components/UI/JobTooltip';
import PdfImg from 'src/assets/images/PDF-file.png';
import ExcelImg from 'src/assets/images/Excel-file.png';
import VideoImg from 'src/assets/images/video-file.png';

const imageMimeTypes = ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp", "image/avif", "image/tiff", "image/svg+xml"];
  const pdfMimeTypes = ["application/pdf"];
  const excelMimeTypes = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"];
  const videoMimeTypes = ["video/mp4", "video/quicktime", "video/x-msvideo", "video/x-ms-wmv", "video/mpeg", "video/x-flv", "video/webm", "video/ogg", "video/3gpp", "video/3gpp2"];


    const openDocumet=(link:any)=>{
    if (link != "" && link != undefined && link != null) {
          const newWindow = window.open(link);
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            alert('Popup blocked! Please allow popups for this site to view the document.');
          } else {
            newWindow.focus();
          }
        }
  }

const ViewComplaint = () => {

  const { id } = useParams()
  const navigate = useNavigate();
  const editDealerClickHandler = () => {
    navigate(`${ROUTER.COMPLAINT_EDIT}/${id}`);
  };

  const { error, message, loading, complaintDetails, complaintFiles } = useSelector((state: RootReducerState) => state.ComplaintReducer);

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);

  useEffect(()=>{

    return()=>{
        dispatch(resetComplaintMessage())
    }
  },[])

  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(getComplaintFormByIdLoading(id));
      dispatch(getComplaintDocumentLoading(id));
    }
  }, [id, dispatch]);


  const dealerViewDetails = {
    personalDetails: [
      {
        label: "Job Prefix",
        value: complaintDetails?.jobPrefix
      },
      {
        label: "Complaint",
        value: complaintDetails?.complaintName
      },
    ],
  }

    const documentTemplate = (franchiseDocumet: any) => {
      return (
        <div className='Franchise_Documnets'>
          {
            franchiseDocumet?.length > 0 ? franchiseDocumet?.map((data: any, i: number) => {
              if (pdfMimeTypes.includes(data.mimeType)) {
                return (
                  <JobTooltipMEL key={i} title={data.name} position='bottom'>
                    <div onClick={() => openDocumet(data.fileLink)}>
                      <img src={PdfImg} alt="document" style={{ width: "70px", height: "100px" }} />
                    </div>
                  </JobTooltipMEL>
                );
              } else if (excelMimeTypes.includes(data.mimeType)) {
                return (
                  <JobTooltipMEL key={i} title={data.name} position='bottom'>
                    {/* <i key={i} onClick={() => openDocumet(data.fileLink)} className="fas fa-file-csv"></i> */}
                    <div onClick={() => openDocumet(data.fileLink)}>
                      <img src={ExcelImg} alt="document" style={{ width: "70px", height: "100px" }} />
                    </div>
                  </JobTooltipMEL>
                );
              } else if (imageMimeTypes.includes(data.mimeType)) {
                return (
                  <JobTooltipMEL key={i} title={data.name} position='bottom'>
                    {/* <i key={i} onClick={() => openDocumet(data.fileLink)} className="fas fas fa-image"></i> */}
                    <div onClick={() => openDocumet(data.fileLink)}>
                      <img src={data.fileLink} alt="document" style={{ width: "70px", height: "100px" }} />
                    </div>
                  </JobTooltipMEL>
                );
              }else if (videoMimeTypes.includes(data.mimeType)) {
                return (
                  <JobTooltipMEL key={i} title={data.name} position='bottom'>
                    {/* <i key={i} onClick={() => openDocumet(data.fileLink)} className="fas fas fa-image"></i> */}
                    <div onClick={() => openDocumet(data.fileLink)}>
                      <img src={VideoImg} alt="document" style={{ width: "70px", height: "100px" }} />
                    </div>
                  </JobTooltipMEL>
                );
              } else {
                return (
                  <JobTooltipMEL key={i} title={data.name} position='bottom'>
                    {/* <i key={i} onClick={() => openDocumet(data.fileLink)} className="fas fa-file-alt"></i> */}
                    <div onClick={() => openDocumet(data.fileLink)}>
                      <img src={FileImg} alt="document" style={{ width: "70px", height: "100px" }} />
                    </div>
                  </JobTooltipMEL>
                );
              }
            }) : <span style={{ fontSize: "14px" }}>No attachement here</span>
          }
        </div>
      );
    };
console.log("complaintFiles",complaintFiles)
  return (
    <div className="pagecontent " id="view-brand">
      <BreadcrumbWithFilter
        title="Complaints"
        titlePath={ROUTER.COMPLAINT_GRID}
        breadcrumbItem="Complaints Details"
        isShowCreate={false}
        isShowFilter={false}
        filter={false}
        isShowFirstButton={true}
        firstButtonLabel='Edit Complaint'
        onFirstButtonClick={editDealerClickHandler}
      />
      <Row>
        <div className="view">
          <div className="general-details">
            <b>General Details</b>
          </div>
          <div className="subview">
            <Row>
              {
                dealerViewDetails.personalDetails.map((data, index) => {
                  return (
                    <Col lg={3} key={index} className={"mt-4"}>
                      <div className='mb-2'>{data.label}</div>
                      <b>{data.value ? data.value : <div className='none-text'>-</div>}</b>
                    </Col>
                  )
                })
              }
            </Row>

            <Row className='mt-4'>
                <p className='text-bold mb-1'>Complaint Points</p>
                <div dangerouslySetInnerHTML={{ __html: complaintDetails?.complaintPoints }}></div>
            </Row>
            <Row className='mt-4'>
                <p className='text-bold mb-1'>Uploaded Documents</p>
                {documentTemplate(complaintFiles?.filter((file:any)=> file.isUploaded == true))}
            </Row>

          </div>
        </div>
      </Row>
    </div>
  );
};

export default ViewComplaint;
